import { render, staticRenderFns } from "./NewsBannerSlider.vue?vue&type=template&id=7643c139"
import script from "./NewsBannerSlider.vue?vue&type=script&lang=js"
export * from "./NewsBannerSlider.vue?vue&type=script&lang=js"
import style0 from "./NewsBannerSlider.vue?vue&type=style&index=0&id=7643c139&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports